import { defineStore } from 'pinia'
import { INoticeItem } from "@/@types/types";


export const useNoticeStore = defineStore('__notice_mall__', {
  state: (): {
    noticeConf: INoticeItem | null
  } => ({
    noticeConf: null
  }),
  actions: {
    setNoticeConf(params: INoticeItem | null) {
      this.noticeConf = params
    },
  }
})
